import { render } from "./NcrmContractItemFieldEditor.vue?vue&type=template&id=4be4a97e&scoped=true"
import script from "./NcrmContractItemFieldEditor.vue?vue&type=script&lang=js"
export * from "./NcrmContractItemFieldEditor.vue?vue&type=script&lang=js"

import "./NcrmContractItemFieldEditor.vue?vue&type=style&index=0&id=4be4a97e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be4a97e"]])

export default __exports__